import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ItemLocationDetailFragmentDoc } from '../fragments/itemLocationDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateItemLocationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  name: Types.Scalars['String'];
  type?: Types.InputMaybe<Types.Scalars['String']>;
  event_id?: Types.InputMaybe<Types.Scalars['String']>;
  disabled?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type UpdateItemLocationMutation = { __typename?: 'Mutation', updateItemLocation: { __typename?: 'ItemLocation', id: string, name: string, type?: string | null, disabled_at?: string | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null } | null, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null } };


export const UpdateItemLocationDocument = gql`
    mutation UpdateItemLocation($id: ID!, $name: String!, $type: String, $event_id: String, $disabled: Boolean) {
  updateItemLocation(
    id: $id
    name: $name
    type: $type
    event_id: $event_id
    disabled: $disabled
  ) {
    ...ItemLocationDetail
  }
}
    ${ItemLocationDetailFragmentDoc}`;
export type UpdateItemLocationMutationFn = Apollo.MutationFunction<UpdateItemLocationMutation, UpdateItemLocationMutationVariables>;

/**
 * __useUpdateItemLocationMutation__
 *
 * To run a mutation, you first call `useUpdateItemLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemLocationMutation, { data, loading, error }] = useUpdateItemLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      event_id: // value for 'event_id'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useUpdateItemLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemLocationMutation, UpdateItemLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemLocationMutation, UpdateItemLocationMutationVariables>(UpdateItemLocationDocument, options);
      }
export type UpdateItemLocationMutationHookResult = ReturnType<typeof useUpdateItemLocationMutation>;
export type UpdateItemLocationMutationResult = Apollo.MutationResult<UpdateItemLocationMutation>;
export type UpdateItemLocationMutationOptions = Apollo.BaseMutationOptions<UpdateItemLocationMutation, UpdateItemLocationMutationVariables>;